// import React, { useState } from 'react';

// const Whywe = () => {
//   const services = [
//     {
//       title: 'IT Expertise & Consulting',
//       description: 'End-to-end enterprise resource planning solutions with expert guidance from strategy to deployment and optimization.',
//       bgColor: '#1a2634', // dark blue
//       textColor: '#ffffff', // white
//       hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/What%20Are%20Managed%20Services,%20and%20When%20Do%20You%20Need%20Them_.jpg?updatedAt=1741073873308',
//       gridClass: 'col-span-12 md:col-span-8 md:row-span-2'
//     },
//     {
//       title: '24/7 Support',
//       description: 'Strategic technology planning aligned with your business goals to drive digital transformation and competitive advantage.',
//       bgColor: '#f0f9ff', // light blue
//       textColor: '#1a2634', // dark blue
//       hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/Customer%20Support%20Pictures%20_%20Download%20Free%20Images%20on%20Unsplash.png?updatedAt=1741073876207',
//       gridClass: 'col-span-12 md:col-span-4'
//     },
//     {
//       title: 'Streamline Operations',
//       description: 'Tailored software solutions designed to address your unique business challenges and optimize operational efficiency.',
//       bgColor: '#38bdf8', // cyan
//       textColor: '#ffffff', // white
//       hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/The%20Role%20of%20AI%20in%20streamlining%20Business%20Processes%20and%20Increasing%20Efficiency.png?updatedAt=1741073874251',
//       gridClass: 'col-span-12 md:col-span-4'
//     },
//     {
//       title: 'Data Analytics & AI Solutions',
//       description: 'Unlock the potential of your data with advanced analytics and AI-powered insights to drive informed decision-making.',
//       bgColor: '#1e3a5c', // medium blue
//       textColor: '#ffffff', // white
//       hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/8%20Best%20AI%20Data%20Analytics%20Software%20&%20Tools%20To%20Try%20(1).png?updatedAt=1741073875263',
//       gridClass: 'col-span-12 md:col-span-6'
//     },
//     {
//       title: 'Track Record',
//       description: 'Transform legacy systems into modern, scalable applications that enhance your business agility and competitive edge.',
//       bgColor: '#0f172a', // slate dark
//       textColor: '#ffffff', // white
//       hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/Boosting%20Retail%20Profitability%20with%20Unified%20Analytics%20-%20Coruzant%20Technologies.jpg?updatedAt=1741073873096',
//       gridClass: 'col-span-12 md:col-span-6'
//     },
//   ];

//   const [hoveredService, setHoveredService] = useState(null);

//   return (
//     <div className="w-full max-w-6xl mx-auto px-4 py-8 md:px-6 lg:px-8">
//       <div className="mb-8 md:mb-12">
//         <h2 className="text-orange-500 text-lg md:text-xl font-medium mb-2">Meet our assistance</h2>
//         <h1 className="text-slate-900 text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">Why to Choose Our Services</h1>
//         <p className="text-gray-600 text-base md:text-lg max-w-2xl">
//           We deliver comprehensive IT and business solutions that transform organizations, optimize operations, and drive sustainable growth through innovative technology implementation.
//         </p>
//       </div>
      
//       <div className="grid grid-cols-12 gap-2 md:gap-3 lg:gap-4">
//         {services.map((service, index) => (
//           <div
//             key={index}
//             className={`${service.gridClass} relative cursor-pointer transition-all duration-300 ease-in-out`}
//             style={{
//               backgroundColor: service.bgColor,
//               minHeight: '220px',
//             }}
//             onMouseEnter={() => setHoveredService(index)}
//             onMouseLeave={() => setHoveredService(null)}
//           >
//             <div
//               className="absolute inset-0 transition-opacity duration-500 ease-in-out"
//               style={{
//                 opacity: hoveredService === index ? 0.3 : 0,
//               }}
//             >
//               <img
//                 src={service.hoverImage}
//                 alt={service.title}
//                 className="w-full h-full object-cover"
//               />
//             </div>
            
//             <div className="p-4 md:p-6 h-full flex flex-col justify-between relative z-10">
//               <h2 className="text-xl md:text-2xl font-medium" style={{ color: service.textColor }}>
//                 {service.title}
//               </h2>
//               <p className="text-sm md:text-base transition-opacity duration-300 ease-in-out"
//                 style={{
//                   color: service.textColor,
//                   opacity: hoveredService === index ? 1 : 0,
//                 }}>
//                 {service.description}
//               </p>
              
//               <div className="mt-4 w-8 h-8 rounded-full flex items-center justify-center transition-opacity duration-300 ease-in-out"
//                 style={{
//                   border: `1px solid ${service.textColor}`,
//                   opacity: hoveredService === index ? 1 : 0,
//                 }}>
//                 <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" style={{ color: service.textColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                 </svg>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Whywe;


import React, { useState } from 'react';

const Whywe = () => {
  const services = [
    // Your services data remains the same
        {
      title: 'IT Expertise & Consulting',
      description: 'End-to-end enterprise resource planning solutions with expert guidance from strategy to deployment and optimization.',
      bgColor: '#1a2634', // dark blue
      textColor: '#ffffff', // white
      hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/What%20Are%20Managed%20Services,%20and%20When%20Do%20You%20Need%20Them_.jpg?updatedAt=1741073873308',
      gridClass: 'col-span-12 md:col-span-8 md:row-span-2'
    },
    {
      title: '24/7 Support',
      description: 'Strategic technology planning aligned with your business goals to drive digital transformation and competitive advantage.',
      bgColor: '#f0f9ff', // light blue
      textColor: '#1a2634', // dark blue
      hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/Customer%20Support%20Pictures%20_%20Download%20Free%20Images%20on%20Unsplash.png?updatedAt=1741073876207',
      gridClass: 'col-span-12 md:col-span-4'
    },
    {
      title: 'Streamline Operations',
      description: 'Tailored software solutions designed to address your unique business challenges and optimize operational efficiency.',
      bgColor: '#38bdf8', // cyan
      textColor: '#ffffff', // white
      hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/The%20Role%20of%20AI%20in%20streamlining%20Business%20Processes%20and%20Increasing%20Efficiency.png?updatedAt=1741073874251',
      gridClass: 'col-span-12 md:col-span-4'
    },
    {
      title: 'Data Analytics & AI Solutions',
      description: 'Unlock the potential of your data with advanced analytics and AI-powered insights to drive informed decision-making.',
      bgColor: '#1e3a5c', // medium blue
      textColor: '#ffffff', // white
      hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/8%20Best%20AI%20Data%20Analytics%20Software%20&%20Tools%20To%20Try%20(1).png?updatedAt=1741073875263',
      gridClass: 'col-span-12 md:col-span-6'
    },
    {
      title: 'Track Record',
      description: 'Transform legacy systems into modern, scalable applications that enhance your business agility and competitive edge.',
      bgColor: '#0f172a', // slate dark
      textColor: '#ffffff', // white
      hoverImage: 'https://ik.imagekit.io/kqumni8l2/HomePage/whywe/Boosting%20Retail%20Profitability%20with%20Unified%20Analytics%20-%20Coruzant%20Technologies.jpg?updatedAt=1741073873096',
      gridClass: 'col-span-12 md:col-span-6'
    },
  ];

  const [hoveredService, setHoveredService] = useState(null);

  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-8 md:px-6 lg:px-8">
      <div className="mb-8 md:mb-12">
        {/* Your header content remains the same */}
      </div>
      
      <div className="grid grid-cols-12 gap-2 md:gap-3 lg:gap-4">
        {services.map((service, index) => (
          <div
            key={index}
            className={`${service.gridClass} relative cursor-pointer transition-all duration-300 ease-in-out`}
            style={{ 
              backgroundColor: service.bgColor,
              minHeight: '220px',
            }}
            onMouseEnter={() => setHoveredService(index)}
            onMouseLeave={() => setHoveredService(null)}
          >
            <div 
              className="absolute inset-0 transition-opacity duration-500 ease-in-out"
              style={{
                opacity: hoveredService === index ? 1 : 0, // Change here
              }}
            >
              <img
                src={service.hoverImage}
                alt={service.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-4 md:p-6 h-full flex flex-col justify-between relative z-10">
              <h2 className="text-xl md:text-2xl font-medium" style={{ color: service.textColor }}>
                {service.title}
              </h2>
              <p className="text-sm md:text-base transition-opacity duration-300 ease-in-out" 
                style={{ 
                  color: service.textColor, 
                  opacity: hoveredService === index ? 1 : 0,
                }}>
                {service.description}
              </p>
              
              <div className="mt-4 w-8 h-8 rounded-full flex items-center justify-center transition-opacity duration-300 ease-in-out"
                style={{ 
                  border: `1px solid ${service.textColor}`,
                  opacity: hoveredService === index ? 1 : 0,
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" style={{ color: service.textColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Whywe;
